// Copyright (c) Meta Platforms, Inc. and affiliates.
'use client';

/**
 * @file AvatarGroupContext.ts
 * @input None (pure context definition)
 * @output Exports AvatarGroup context and useAvatarGroup hook
 * @position Shared context; consumed by children for group-aware styling
 */
import { createContext, use } from 'react';
export const AvatarGroupContext = /*#__PURE__*/createContext(null);
AvatarGroupContext.displayName = 'AvatarGroupContext';
export function useAvatarGroup() {
  return use(AvatarGroupContext);
}